import Marionette from 'backbone.marionette';
import Navigator from 'app';
import aboutController from './about_controller';
var aboutRouter = Marionette.AppRouter.extend({
  appRoutes: {
    "about": "showAbout"
  }
});
var API = {
  showAbout: function () {
    aboutController.showAbout();
    // Navigator.updateAnalytics("about");
  }
};

Navigator.vent.on("about:show", function () {
  Navigator.navigate("about");
  API.showAbout();
});
Navigator.on("before:start", function () {
  new aboutRouter({
    controller: API
  });
});